import { useI18n } from 'next-localization';

import { ProviderLocation } from '@/features/profile/profile.types';
import { cn } from '@/lib/utils';
import { NeuButton } from '@hcahealthcaredpx/neutron-react';
import { MapPin } from '@xsf/shared-lib/components/azure-map';

import { Distance } from '../distance';
import styles from './modal.module.css';

export const LocationsList = ({
  locations,
  chooseLocationHandler,
  closeModal,
  selectedId,
}: {
  locations: ProviderLocation[];
  chooseLocationHandler: (location: ProviderLocation) => void;
  closeModal: () => void;
  selectedId: string;
}): JSX.Element => {
  const { t } = useI18n();
  // const { setSelectedLocationId } = useContext(MapsContext);

  const getDistanceClass = (distance: string | null) => {
    return Number(distance) > 0 && !Number.isNaN(Number(distance))
      ? 'justify-content-between'
      : 'justify-content-end';
  };

  const sortByDistance = (a: ProviderLocation, b: ProviderLocation) =>
    Number(a.distance) - Number(b.distance);

  return (
    <div className={styles.listWrapper}>
      {locations.sort(sortByDistance).map((location, index) => {
        const isSelectedLocation = location.id === selectedId;

        return (
          <div className={styles.locationRowWrapper} key={location.id}>
            <div className="d-flex align-items-start">
              <div className="mt-3" aria-hidden="true">
                <MapPin color={isSelectedLocation ? '#be552e' : '#03173e'} />
              </div>

              <div className="w-100" tabIndex={-1}>
                <span className="sr-only">
                  Address {index + 1} of {locations?.length}
                </span>
                <h2 className={cn('fw-semibold', styles.locationName)}>{location.name}</h2>
                <p className={cn('fw-normal mb-0', styles.locationAddress)}>
                  {location.street}
                  <br />
                  {location.city}, {location.state} {location.zip}
                </p>
                {isSelectedLocation ? (
                  <span className="sr-only">This address is currently selected</span>
                ) : null}
                <div
                  className={cn(
                    'd-flex align-items-center',
                    getDistanceClass(location.distance),
                    styles.locationDistance
                  )}
                >
                  {Number(location.distance) > 0 && !Number.isNaN(Number(location.distance)) && (
                    <p className="d-flex align-items-center mb-0">
                      <Distance distance={location.distance} isBold={false} showIcon />
                    </p>
                  )}

                  {!isSelectedLocation ? (
                    <NeuButton
                      key={selectedId}
                      onClick={() => {
                        chooseLocationHandler(location);
                        // setSelectedLocationId?.(location.id ?? '');
                        closeModal();
                      }}
                      kind="tertiary"
                    >
                      {t('OAS.ChangeLocation.ChooseLocation')}
                    </NeuButton>
                  ) : (
                    <NeuButton key={selectedId} kind="tertiary" disabled>
                      {t('OAS.ChangeLocation.Selected')}
                    </NeuButton>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
